function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.948 16.603l5.677-14.64A1 1 0 0016.363.658L1.304 5.916a1 1 0 00-.378 1.65l3.152 3.162a.4.4 0 00.497.056l6.677-4.202L7.05 13.26a.4.4 0 00.056.496l3.204 3.194a1 1 0 001.638-.347z",
  fill: "currentColor",
  fillRule: "nonzero"
});
function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgTelegram;